import { render, staticRenderFns } from "./index.vue?vue&type=template&id=04e61135&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/ai-contact/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04e61135')) {
      api.createRecord('04e61135', component.options)
    } else {
      api.reload('04e61135', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=04e61135&", function () {
      api.rerender('04e61135', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/group/belong_users/index.vue"
export default component.exports